import React, { Component } from 'react'
import 'react-circular-progressbar/dist/styles.css';
import NumberFormat from 'react-number-format';
import edit from '../assets/edittable.png'
import deletee from '../assets/delete.png'

export default class TurnoverRow extends Component {
    constructor(props) {
        super(props);
        this.state={
            detailData:[],
        }
    }

    deleteitem(){
        this.props.deleteItem(this.props.id);
    }

    edititem(){
        this.props.editItem(this.props.id);
    }

    onClick(){
        if (this.state.detailData.length>0){
            this.setState({detailData:[]})
        }else{
            let detail = this.props.GetDetailTransaction(this.props.linked_id)
            if (detail!==undefined){
                this.setState({detailData:detail})
            }
        }
    }

    render() {
        return (
            <div className="portfolioRowParent" style={{fontSize:'10px',textAlign:'center',paddingRight:this.props.hasChild?'0px':'5px',cursor:this.props.hasChild?'pointer':'default'}} onClick={this.onClick.bind(this)}>
                <div className="portfolioRow" style={{justifyContent:'flex-start'}}>
                    {this.props.hasChild && <div style={{minWidth:'5px',width:'5px',backgroundColor:'var(--blue2)',borderRadius:'0px 5px 5px 0px'}} />}
                    <div className="portfolioRowContent" style={{maxWidth:'15%',minWidth:'15%',borderLeft:'1px solid var(--gray5)',paddingLeft:'5px',marginLeft:'5px'}}>
                        <div style={{fontWeight:'bold'}}>{this.props.type_lable}</div>
                    </div>
                    <div className="portfolioRowContent" style={{maxWidth:'15%',minWidth:'15%',borderLeft:'1px solid var(--gray5)',paddingLeft:'5px',marginLeft:'5px'}}>
                        <div style={{marginBottom:this.props.basket!==null && this.props.broker!==null ?'8px':'0px'}}>{this.props.basket}</div>
                        <div>{this.props.broker}</div>
                    </div>
                    <div className="portfolioRowContent" style={{maxWidth:'23%',minWidth:'23%',borderLeft:'1px solid var(--gray5)',paddingLeft:'5px',marginLeft:'5px'}}>
                        <div style={{marginBottom:this.props.symbol!==null ?'8px':'0px'}}>{this.props.symbol}</div>
                        <div>{this.props.date}</div>
                    </div>
                    <div className="portfolioRowContent" style={{maxWidth:'32%',minWidth:'32%',marginLeft:'5px'}}>
                        {this.props.cash_change!==0 && <div style={{marginBottom:this.props.quantity!==0 ?'8px':'0px',display:'flex',flexDirection:'row'}}>مبلغ:&nbsp;<div style={{direction:'ltr',color:((this.props.type_id>0 && this.props.type_id<6) || (this.props.type_id>6 && this.props.type_id<9)) && this.props.cash_change!==null && this.props.cash_change < 0 ?'var(--red1)':((this.props.type_id>0 && this.props.type_id<6) || (this.props.type_id>6 && this.props.type_id<9) || this.props.type_id===12) && this.props.cash_change!==null && this.props.cash_change > 0 ?'var(--green1)':'var(--black1)'}}><NumberFormat allowNegative={true} value={this.props.cash_change} displayType={'text'} thousandSeparator={true} /></div></div>}
                        {this.props.quantity!==0 && <div style={{display:'flex',flexDirection:'row'}}>تعداد:&nbsp;<div style={{direction:'ltr'}}><NumberFormat allowNegative={true} value={Math.abs(this.props.quantity)} displayType={'text'} thousandSeparator={true} /></div></div>}
                    </div>
                    <div className="portfolioRowContent" style={{flex:'1',alignItems:'flex-end'}}>
                        <div><img alt="edt" className="myButton" style={{height:'15px'}} src={edit} onClick={this.edititem.bind(this)}/></div>
                        <div style={{height:'8px'}} />
                        <div><img alt="dlt" className="myButton" style={{height:'15px'}} src={deletee} onClick={this.deleteitem.bind(this)}/></div>
                    </div>
                </div>

                {this.state.detailData.length>0 && <div style={{display:'flex',flexDirection:'column',justifyContent:'flex-start',marginBottom:'5px',borderRadius:'5px',overflow:'hidden',marginRight:'5px'}}>
                    {this.state.detailData.map((item,i)=>(
                        <div key={i} className="portfolioRow" style={{justifyContent:'flex-start',margin:'0px 0px',borderTop:'1px solid var(--gray5)',backgroundColor:'var(--gray3)',padding:'0px 4px'}}>
                            <div className="portfolioRowContent" style={{maxWidth:'15%',minWidth:'15%',marginLeft:'5px'}}>
                                <div style={{fontWeight:'bold'}}>{item.type_lable}</div>
                            </div>
                            <div className="portfolioRowContent" style={{maxWidth:'15%',minWidth:'15%',marginLeft:'5px'}}>
                                <div style={{marginBottom:item.basket!==null && item.broker!==null ?'8px':'0px'}}>{item.basket}</div>
                                <div>{item.broker}</div>
                            </div>
                            <div className="portfolioRowContent" style={{maxWidth:'23%',minWidth:'23%',marginLeft:'5px'}}>
                                <div style={{marginBottom:item.symbol!==null ?'8px':'0px'}}>{item.symbol}</div>
                                <div>{item.date}</div>
                            </div>
                            <div className="portfolioRowContent" style={{flex:'1'}}>
                                {item.cash_change!==0 && <div style={{marginBottom:item.quantity!==0 ?'8px':'0px',display:'flex',flexDirection:'row'}}>مبلغ:&nbsp;<div style={{direction:'ltr',color:((item.type_id>0 && item.type_id<6) || (item.type_id>6 && item.type_id<9)) && item.cash_change!==null && item.cash_change < 0 ?'var(--red1)':((item.type_id>0 && item.type_id<6) || (item.type_id>6 && item.type_id<9) || item.type_id===12) && item.cash_change!==null && item.cash_change > 0 ?'var(--green1)':'var(--black1)'}}><NumberFormat allowNegative={true} value={item.cash_change} displayType={'text'} thousandSeparator={true} /></div></div>}
                                {item.quantity!==0 && <div style={{display:'flex',flexDirection:'row'}}>تعداد:&nbsp;<div style={{direction:'ltr'}}><NumberFormat allowNegative={true} value={Math.abs(item.quantity)} displayType={'text'} thousandSeparator={true} /></div></div>}
                            </div>
                        </div>
                    ))}
                </div>}
            </div>
        )
    }
}
